import React, { useContext, useState, useEffect } from "react";
import { DataContext } from "../../contexts/DataContext";
import styled from "styled-components";
import Games from "../Games/Games";
import Live from "./Live";
import EFL from "./EFL";
import { useParams, Switch, Route } from "react-router-dom";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import LeftSideBar from "../LeftSideBar/LeftSideBar";
import NavBar from "../TopBar/NavBar";
import Engine from "../Engine/Engine";
import PS from "./PS";

const MainDiv = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
`;
const LeftBar = styled.div`
  display: flex;
  min-width: 44px;
  box-shadow: 3px -1px 3px 0 rgb(0 0 0 / 42%);
  background-color: #202731;
`;
const Content = styled.div`
  display: flex;
  box-sizing: border-box;
  flex: 1;
  width: 100vw;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
export default function Main() {
  const { view, setView, editPlayer, setEditPlayer } = useContext(UIContext);
  const { teams, fixtures, selectedGame, setSelectedGame, players } =
    useContext(DataContext);
  const { animateGraphic, graphicInPreview, animateOffGraphic, clearPVW } =
    useContext(GraphicsContext);
  const { setSelectedGameID } = useContext(DataContext);

  const [selectedPlayer, setSelectedPlayer] = useState();
  const [selectedSubPlayer, setSelectedSubPlayer] = useState();
  let { gameID } = useParams();

  useEffect(() => {
    if (players && selectedPlayer) {
      let p = players.find((p) => p.uuid === selectedPlayer.player);
      setSelectedPlayer({ ...p, player: p.uuid });
    }
  }, [players]);

  useEffect(() => {
    if (gameID) {
      setSelectedGameID(gameID);
      if (view === VIEW_CONSTS.matchSelect) {
        setView(VIEW_CONSTS.live);
      }
    } else {
      setView(VIEW_CONSTS.matchSelect);
      setSelectedGame(null);
    }
  }, [fixtures, gameID]);

  useEffect(() => {
    function handleKeyDown(e) {
      console.log(e.keyCode);
      if (e.keyCode === 119 || e.keyCode === 109) {
        if (graphicInPreview) {
          animateGraphic(graphicInPreview.name);
        }
        e.preventDefault();
      } else if (e.keyCode === 120 || e.keyCode === 106) {
        if (graphicInPreview) {
          animateOffGraphic(graphicInPreview.name);
        }
        e.preventDefault();
      } else if (e.keyCode === 81 && e.ctrlKey) {
        if (graphicInPreview) {
          clearPVW(graphicInPreview.name);
        }
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [graphicInPreview]);

  return (
    <div>
      <Content>
        <Switch>
          {/* <Route path="/efl/:gameID">
            <LeftBar>
              <LeftSideBar view={VIEW_CONSTS.live} />
            </LeftBar>
            <EFL
              setSelectedPlayer={setSelectedPlayer}
              selectedPlayer={selectedPlayer}
              view={view}
              setView={setView}
            />
          </Route>
          <Route path="/efl">
            <Column>
              {!window.hideHeader && <NavBar />}

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.matchSelect} />
                </LeftBar>
                <Games
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDiv>
            </Column>
          </Route> */}
          <Route path="/:gameID">
            <LeftBar>
              <LeftSideBar view={VIEW_CONSTS.live} />
            </LeftBar>
            {(window.ENV?.REACT_APP_PS || process.env.REACT_APP_PS) && (
              <PS
                setSelectedPlayer={setSelectedPlayer}
                selectedPlayer={selectedPlayer}
                setSelectedSubPlayer={setSelectedSubPlayer}
                selectedSubPlayer={selectedSubPlayer}
                view={view}
                setView={setView}
              />
            )}
            {(window.ENV?.REACT_APP_IMG || process.env.REACT_APP_IMG) && (
              <EFL
                setSelectedPlayer={setSelectedPlayer}
                selectedPlayer={selectedPlayer}
                setSelectedSubPlayer={setSelectedSubPlayer}
                selectedSubPlayer={selectedSubPlayer}
                view={view}
                setView={setView}
              />
            )}
            {!window.ENV?.REACT_APP_IMG &&
              !process.env.REACT_APP_IMG &&
              !window.ENV?.REACT_APP_PS &&
              !process.env.REACT_APP_PS && (
                <Live
                  setSelectedPlayer={setSelectedPlayer}
                  selectedPlayer={selectedPlayer}
                  view={view}
                  setView={setView}
                />
              )}
          </Route>
          <Route path="/">
            <Column>
              {!window.hideHeader && <NavBar />}

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.matchSelect} />
                </LeftBar>
                <Games
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDiv>
            </Column>
          </Route>
        </Switch>
      </Content>
    </div>
  );
}
